import { render, staticRenderFns } from "./FSocialMediaLinks.vue?vue&type=template&id=6ae8e642&"
import script from "./FSocialMediaLinks.vue?vue&type=script&lang=js&"
export * from "./FSocialMediaLinks.vue?vue&type=script&lang=js&"
import style0 from "./FSocialMediaLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports